import { render, staticRenderFns } from "./CurriculumColorContainer.vue?vue&type=template&id=1ecef6e2&scoped=true"
import script from "./CurriculumColorContainer.vue?vue&type=script&lang=js"
export * from "./CurriculumColorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecef6e2",
  null
  
)

export default component.exports